import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const mass = {
    jpath: ['spectra', 'mass'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: (filename, content) => {
        return getMetaFromJcamp(filename, content, {
            mapping: {
                EXPERIMENT: 'experiment',
                INJECTION: 'injection',
                MODE: 'mode',
                INSTRUMENT: 'instrument',
                ANALYZER: 'analyzer',
                IONISATION: 'ionisation',
                CONDITIONS: 'conditions',
                ACCURATEMF: 'accurate.mf',
                ACCURATEMODIF: 'accurate.modification',
                ACCURATERESULT: 'accurate.value',
            },
        });
    },
};
export default mass;
//# sourceMappingURL=mass.js.map